import React, { createContext, useContext, useEffect, useState } from 'react';
import ModalTask from 'components/Organisms/Modals/ModalTask/ModalTask';
import iconCortPng from 'assets/images/home.png';
import Step1 from './Step1/Step1';
import { Button } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import Step2 from './Step2/Step2';
import {
  Entity,
  Loan,
  Task,
  TaskResponse,
  TaskState
} from '../../../../../gql/graphql';
import { useGetTaskResponsesByTask } from '../../../../../services/task/querys';
import StateTag from 'components/Atoms/Tags/StateTag/StateTag';
import { findTaskRules } from '../../RulesTaskCards.constanst';
import { ModuleKeys } from 'services/task/modules-keys.constanst';
import { TaskOpenModalContext } from '../../../Private';
import { LoanContext, UpdateDashboardContext } from '../../Dashboard';
import { useRemoveTaskResponse, useTaskChangeState } from 'services/task/mutations';
import CircleTag from 'components/Atoms/Tags/CircleTag/CircleTag';

export const TaskContext = createContext<Task | {}>({});
export const EntityContext = createContext<Entity | {}>({});

interface Props {
  task: Task;
}

const Insurance = ({ task }: Props) => {
  const { value: openContext, setHandler }: any = useContext(TaskOpenModalContext);
  const { setValue: setUpdateDashboard }: any = useContext(UpdateDashboardContext);

  const { execute: removeTaskResponse } = useRemoveTaskResponse();
  const { data: taskResponses, reexecute: getTaskResponses } = useGetTaskResponsesByTask({
    variables: { findResponsesByTask: { taskId: task._id } }
  });
  const { execute: taskChangeState } = useTaskChangeState();

  const [isModalTaskVisible, setModalTaskVisible] = useState(false);
  const [isReview, setIsReview] = useState(false);
  const [step, setStep] = useState(1);
  const [responseStep1, setResponseStep1] = useState<TaskResponse>();
  const [responseStep2, setResponseStep2] = useState<TaskResponse>();
  const [responseStep2Docs, setResponseStep2Docs] = useState<TaskResponse>();
  const [entity, setEntity] = useState<Entity | any>();

  useEffect(() => {
    if (openContext === ModuleKeys.INSURANCE) {
      setModalTaskVisible(true);
      setHandler();
    } else if(!!openContext)
      setModalTaskVisible(false);
  }, [openContext]);

  useEffect(() => {
    if (isModalTaskVisible)
      getTaskResponses({ requestPolicy: 'network-only' });
  }, [isModalTaskVisible])

  useEffect(() => {
    const step1: any = taskResponses?.find((item) => item.step === 1);
    setResponseStep1(step1);
    
    if (step1?.key === 'no') setStep(2);

    const step2: any = taskResponses?.find((item) => item.step === 2);
    const step2Docs: any = taskResponses?.find((item) => item.step === 2 && (item.files?.length ?? 0) > 0)
    setResponseStep2(step2);
    setResponseStep2Docs(step2Docs);
    setIsReview(step2?.state === TaskState.Review);
  }, [taskResponses]);

  const onHelpDocs = () => {
    console.log('onHelpDocs');
  };

  const resetTask = (openModal: Function) => {
    //const docTitle = loanDocs?.find(item => item.key === 'insurance');
    //window.open(docTitle?.file?.url, "_blank");
    for (const response of task.responses) {
      removeTaskResponse({ taskResponseId: response._id });
    }

    taskChangeState({ taskId: task._id, newState: TaskState.Incomplete });
    setUpdateDashboard(true);
    setStep(1);
    getTaskResponses({ requestPolicy: 'network-only' });
    openModal(true);
    
  }

  const renderTracker = () => (
    <div style={{ height: '100%' }}>
      <span className='title-summary'>Task summary</span>
      <div className="mt-20">
        <p className="placeholder">
          My insurance is{' '}
          {step === 2 &&
            <span className="tag-blue">
              through an agent
            </span>
          }
          {step === 2 && responseStep2Docs && 
            <>
              <p
                className="placeholder"
                style={{ marginTop: 45, fontWeight: 500 }}
              >
                Document status{' '}
              </p>
              <div className="owners-tags mt-10">
                <span> {responseStep2Docs?.files?.filter(file => file.state !== "request_error").length || 0}/1 documents submitted</span>
              </div>

              <div className="mt-10 circles-tags">
                <CircleTag
                  state={responseStep2Docs?.state || 'DRAFT'}
                  tagKey={'lala'}
                />
              </div>
            </>
          }
        </p>
      </div>
    </div>
  );

  const { taskName } = findTaskRules(ModuleKeys.INSURANCE);
  
  return (
    <TaskContext.Provider value={task}>
      <EntityContext.Provider value={entity}>
        <ModalTask
          visible={isModalTaskVisible}
          handlerSetVisibile={setModalTaskVisible}
          isConfirmModalClose={task.state !== TaskState.Approved && !isReview}
          disabledDots={step === 2}
          responses={taskResponses}
          renderButtonTrigger={(openModal: any) => (
            <>
              {task?.state !== TaskState.Review && task?.state !== TaskState.Approved &&
                <Button
                className={`button-open-modal button-open-modal-${task.state}`}
                onClick={() => openModal(true)}
              >
                {(task.state === TaskState.Incomplete) ? 
                  'Complete task' :
                  (task.state === TaskState.RequestError) ? 'Resolve issues' :
                  'Begin Task'
                }
              </Button>
              }
              {(task?.state === TaskState.Review || task?.state === TaskState.Approved) &&
                <Button
                  className={`button-open-modal button-open-modal-${task.state}`}
                  onClick={() => resetTask(openModal)}
                >
                  Change insurance type
                </Button>
              }
            </>
          )}
          header={{
            title: <span>{taskName.toUpperCase()}</span>,
            actionLeft: (
              isReview ? <StateTag state={TaskState.Review} size="large" /> : <img src={iconCortPng} alt="icon" className="paperPng" />
            ),
            actionRight: (
              <Button
                className="button button-transparent"
                onClick={() => onHelpDocs()}
              >
                <QuestionCircleOutlined />
                Help docs
              </Button>
            )
          }}
          animationDirection="onRight"
          stepsTotal={2}
          currentStep={step}
          setStep={setStep}
          tracker={renderTracker()}
        >
          <section className="children AchPaymentForm">
            {step === 1 && (
              <Step1
                setStep={setStep}
                closeTask={() => setModalTaskVisible(false)}
              />
            )}
            {step === 2 && (
              <Step2
                setStep={setStep}
                closeTask={() => setModalTaskVisible(false)}
              />
            )}
          </section>
        </ModalTask>
      </EntityContext.Provider>
    </TaskContext.Provider>
  );
};
export default Insurance;
